<script>
    import { Router, Link, Route, navigate } from "svelte-routing";
    import { onDestroy, onMount, tick } from 'svelte';
    import { _completeExamData, _userObj } from "./store.js";
  import LoadingProgress from "./LoadingProgress.svelte";

    export let doneTestId;
    let remainingTimeForResult = 0;
    let h, m, s = 1;
    let days;
    let userObj
    let rank;
    let setIntervalForResult;
    let resultDate;
    let sectionalResult = {}
    let testSections = []
    let chart = {}
    let doneTestObj = {
        total: {
            totalQuestions: 0,
            totalPMarks: 0,
            totalNMarks: 0,
            totalAttempted: 0,
            totalCorrectAns: 0,
            totalWrongAns: 0,
            totalNotAnswered: 0,
            totalNotVisited: 0,
            totalMarks: 0,
            maximumMarks: 0
        }
    }

    let rankList = [];
    let testDuration = 0;
    var labelsArr = [200, 150, 100, 50]
    let loading = true

    

    const userData = _userObj.subscribe(value => { userObj = value });

    function formatAMPM(date) {
        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    function calcYScale(scale, maximumMarks) {
        let temp = 0
        let arr = []
        while (temp < maximumMarks) {
            temp += scale;
            arr.push(temp)
        }
        return arr;
    }
    function draw_graphUI(doneTestObj, rankList) {

        var totalMarks = [];
        var myMarks = doneTestObj.total.totalMarks; //my section marks
        var maximumMarks = doneTestObj.total.maximumMarks

        var totalMarks = rankList.map(function (b) { return b.total.totalMarks }); //all student section marks
        var averageMark = (totalMarks.reduce(function (runningTotal, popularity) { return runningTotal + popularity }, 0)) / totalMarks.length;

        averageMark = Math.round(averageMark)
        let divScale = 5;
        var scale = maximumMarks / divScale;
        scale = Math.round(scale);

        // alert(JSON.stringify({ scale, maximumMarks}))
        // need to think this properly - Gaurav
        if(scale == 0) return;
        let scaleYArray = calcYScale(scale, maximumMarks);

        var unitScale = scaleYArray[0];
        var lastScale = scaleYArray[scaleYArray - 1];
        labelsArr = scaleYArray.reverse()
        labelsArr.push(0)

        var subject = "Chemistry"
        var container = document.getElementById("graph");
        container.style.height = ((labelsArr.length - 1) * 50 + 25) + "px"
        var labels = document.getElementById("labels");
        var dnl = container.getElementsByTagName("span");
        var gUl = container.getElementsByTagName("ul");
        var gDiv = container.getElementsByTagName("div");
        for (let index = 0; index < gDiv.length - 1; index++) {
            gDiv[index].style.height = (50) + "px"
        }
        gUl[0].style.height = ((labelsArr.length - 1) * 50) + "px" //adjust zero length

        for (var i = 0; i < dnl.length; i++) {

            var list = dnl[i].getElementsByTagName("li");
            var sitem = dnl.item(i);
            sitem.style.left = (i * 100 + 20) + "px";
            sitem.style['margin-left'] = (i * 10) + "px";

            for (var j = 0; j < list.length; j++) {
                var item = list.item(j);
                var value = 0;
                value = j == 0 ? myMarks : averageMark;
                item.style.height = ((value / unitScale) * 50) + 10 + "px";
                let t = (value / unitScale);
                if (t >= 1) {
                    item.style.top = ((4 * 50) - (value / unitScale) - value) + "px"
                } else {
                    item.style.top = ((4 * 50) + ((value / unitScale) * 100) - value) + "px";
                }
                item.style.left = (20) + "px";
                if (j == 1) {
                    item.style["border-top"] = 2 + "px solid #000fff"
                    item.style["background"] = "transparent"
                }

                item.innerHTML = value;
                item.style.visibility = "visible";
            }
            var left = (i * 110 + 80) + "px";
            labels.innerHTML = labels.innerHTML +
                "<span style='position:absolute;top:0px;left:" +
                left + ";background:#fff'>" + subject + "</span>"
        }

    }


    function getSectionCounts(sections, testStats) {


        var testStatsObj = {};

        testStats.forEach(aTestStat => {
            testStatsObj[aTestStat.questionId] = aTestStat;
        });


        var sectionObj = {};

        sections.forEach(aSection => {
            var sectionName = aSection.title;
            var sectionResult = {
                total: 0,
                correct: 0,
                wrong: 0,
                notAttempted: 0,
                pMarks: 0,
                nMarks: 0,
                marks: 0,
                totalAttempted: 0,

            }
            const DEFAULT_MARKS = 1;
            aSection.questions.forEach(aQuestion => {
                if (!sectionObj[sectionName]) sectionObj[sectionName] = {}

                // if(testStatsObj[aQuestion].visited) sectionResult.totalAttempted++;

                sectionResult.total++;

                if (testStatsObj[aQuestion]) {
                    sectionResult.marks += testStatsObj[aQuestion].marks;
                    if (testStatsObj[aQuestion].correct) {
                        sectionResult.correct++;
                    }
                    if (!testStatsObj[aQuestion].correct && testStatsObj[aQuestion].hasOwnProperty('correct')) {
                        sectionResult.wrong++;
                    }

                    if (testStatsObj[aQuestion].answer) sectionResult.totalAttempted++;

                } else {
                    sectionResult.notAttempted++;
                    sectionResult.totalMarks += DEFAULT_MARKS; // TODO: remove this line


                }


            });
            sectionObj[sectionName].result = sectionResult;
        });

        return sectionObj;
    }

    function doChartCalculations(doneTestObj, rankList, chartResult) {
        var sections = doneTestObj.testObj.sections;
        var sectionObj = getSectionCounts(sections, doneTestObj.testStats)

        var highestsSectionObj = {

        }
        var avgerageSectionObj = {

        }
        chartResult.forEach(aUserStats => {
            var aSectionObj = getSectionCounts(sections, aUserStats.testStats)
            for (const key in aSectionObj) {
                if (Object.hasOwnProperty.call(aSectionObj, key)) {
                    aSectionObj[key].user = aUserStats.userData;
                    const aSection = aSectionObj[key];
                    if (!highestsSectionObj[key]) highestsSectionObj[key] = aSection;
                    if (!avgerageSectionObj[key]) avgerageSectionObj[key] = { result: { marks: 0 } };

                    if (aSection.result.marks > highestsSectionObj[key].result.marks) {
                        highestsSectionObj[key] = aSection;
                    }
                    avgerageSectionObj[key].result.marks += (aSection.result.marks) / (chartResult.length);
                }
            }

        });

        sectionalResult = sectionObj

        return { sectionObj, highestsSectionObj, avgerageSectionObj };

        // var sectionList = []

        // var sectionList = {};

        // chartResult.forEach(aUserStat => {

        // });

    }
    function draw_graphUI2(doneTestObj, rankList, chartResult) {
        var simplifiedData = doChartCalculations(doneTestObj, rankList, chartResult);
        // renderChartjs(simplifiedData.sectionObj);
        renderApexCharts(simplifiedData.sectionObj, simplifiedData.highestsSectionObj, simplifiedData.avgerageSectionObj, doneTestObj.sectionObj);
    }

    function renderApexCharts(simplifiedData, topperData, avgData, totalData) {
        var labels = Object.keys(simplifiedData);
        var data = [];
        for (const key in simplifiedData) {
            if (Object.hasOwnProperty.call(simplifiedData, key)) {
                const aSection = simplifiedData[key];
                const aTopperSection = topperData[key];
                const aAvgSection = avgData[key];
                const aTotalSection = totalData[key];


                data.push(
                    {
                        x: key,
                        y: aSection.result.marks,
                        goals: [
                            {
                                name: 'Total',
                                value: aTotalSection.maximumMarks,
                                strokeWidth: 5,
                                strokeColor: '#000',
                            },
                            {
                                name: 'Average',
                                value: aAvgSection.result.marks,
                                strokeWidth: 5,
                                strokeColor: '#0168fa'
                            },
                            {
                                name: 'Topper' + "( " + (aTopperSection.user[0] ? aTopperSection.user[0].name : "-") + " )",
                                value: aTopperSection.result.marks,
                                strokeWidth: 5,
                                strokeColor: '#775DD0'
                            },

                        ]
                    }
                )

            }
        }
        var options = {
            series: [
                {
                    name: 'Your Marks',
                    data: data
                }
            ],
            chart: {
                toolbar: {
                    show: false
                },
                height: 350,
                type: 'bar'
            },
            plotOptions: {
                bar: {
                    columnWidth: '60%'
                }
            },
            colors: ['#0168fa88'],
            dataLabels: {
                enabled: false
            },
            legend: {
                show: true,
                showForSingleSeries: true,
                customLegendItems: ['Your Marks', 'Average', 'Topper', "Total"],
                markers: {
                    fillColors: ['#0168fa88', '#0168fa', '#775DD0', '#000']
                }
            }
        };
        
        if(!chart.ohYeahThisChartHasBeenRendered){
            chart = new ApexCharts(document.querySelector("#graph3"), options);
            chart.render().then(() => chart.ohYeahThisChartHasBeenRendered = true);
        }
    }

    function renderChartjs(simplifiedData) {
        var labels = Object.keys(simplifiedData);
        var data = [];
        for (const key in simplifiedData) {
            if (Object.hasOwnProperty.call(simplifiedData, key)) {
                const aSection = simplifiedData[key];
                data.push(aSection.result.correct)

            }
        }
        var ctx = document.getElementById('graph2').getContext('2d');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: '# Questions',
                    data: data,
                    backgroundColor: 'rgba(54, 162, 235, 0.2)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    borderWidth: 1
                }]
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
    }


    async function api_getChartResult(doneTestId) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
            doneTestId: doneTestId,
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch('/testAPI/getChartResult', requestOptions);
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }
    }
    async function api_getResult(doneTestId) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
            doneTestId: doneTestId,
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch('/testAPI/getResult', requestOptions);
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }
    }

    async function api_getRanks(doneTestId) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
            doneTestId: doneTestId,
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch('/testAPI/getRanks', requestOptions);
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }
    }

    function convertDateObjToStr(date) {
        date = new Date(date);
        var month = "" + (date.getMonth() + 1);
        var day = "" + date.getDate();
        var year = date.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        var dateString = [day, month, year].join("-");
        return dateString;
    }

    async function setResultData(testResult) {

        let rankRes = await api_getRanks(doneTestId);
        //console.log(" rankRes : ", rankRes.rankList);
        rankList = rankRes.rankList;
        rankList.sort(function (a, b) { return b.total.totalMarks - a.total.totalMarks });

        for (let i = 0; i < rankList.length; i++) {
            var aResult = rankList[i]
            if (i > 0) {
                var aPrevResult = rankList[i - 1]

                if (aPrevResult.total.totalMarks == aResult.total.totalMarks) {
                    aResult.rank = aPrevResult.rank
                } else {
                    aResult.rank = aPrevResult.rank + 1;
                }
            } else {
                aResult.rank = 1
                //aResult.rank++ 
            }

            rankList[i] = aResult
        }

        rank = rankList.findIndex(i => i._id == testResult.doneTest._id);
        rank = rankList[rank].rank

        // console.log("rank ",rank);
        let testChartResult = await api_getChartResult(doneTestId);
        // console.log(" testChartResult : ", testChartResult);
        draw_graphUI2(doneTestObj, rankList, testChartResult.rankList);

        draw_graphUI(doneTestObj, rankList);

        // for showing sectional data

        testSections = Object.keys(sectionalResult)

    }

    async function getResultData(a) {

        loading = true
        let testResult = await api_getResult(doneTestId);
        loading = false

        await tick()
        // console.log(" testResult : ", testResult);
        doneTestObj = testResult.doneTest;
        if (a) {
            setResultData(testResult);
            // alert("hi... 1");

        } else if (!testResult.doneTest.testObj.resultDate) {
            setResultData(testResult);
            // alert("hi... 2");


        } else if (doneTestObj.testObj.resultDate) {
            remainingTimeForResult = doneTestObj.testObj.durationForTestResult / 1000;
            resultDate = convertDateObjToStr(testResult.doneTest.testObj.resultDate);
            // alert("hi... 3");

        }

        let startedAt = new Date(doneTestObj.startedAt);
        let endedOn = new Date(doneTestObj.endedOn);
        testDuration = (endedOn - startedAt) / 1000;
        // alert("hi... 4");


    }


    function makeGraph() {
        var year = "2001"
        var container = document.getElementById("graph");
        var labels = document.getElementById("labels");
        var dnl = container.getElementsByTagName("span");
        for (var i = 0; i < dnl.length; i++) {
            var list = dnl[i].getElementsByTagName("li");
            var sitem = dnl.item(i);
            sitem.style.left = (i * 100 + 20) + "px";
            sitem.style['margin-left'] = (i * 10) + "px";
            for (var j = 0; j < list.length; j++) {
                var item = list.item(j);
                var value = item.innerHTML;
                var content = value.split(":");
                value = content[0];
                item.style.height = value + "px";
                item.style.top = (199 - value) + "px";
                item.style.left = (20) + "px";
                if (j == 1) {
                    item.style["border-top"] = 2 + "px solid #000fff"
                    item.style["background"] = "transparent"
                }

                item.innerHTML = value;
                item.style.visibility = "visible";
            }
            var left = (i * 110 + 80) + "px";
            labels.innerHTML = labels.innerHTML +
                "<span style='position:absolute;top:0px;left:" +
                left + ";background:#fff'>" + year + "</span>"
        }
    }

    onMount(async () => {
        // makeGraph()
        userData();
        // _userObj.set(userObj);
        // console.log("user>>>>>", userObj)
        window.isExamEnded = true;
        getResultData();

        setIntervalForResult = setInterval(function () {

            remainingTimeForResult--;
            var duration = remainingTimeForResult
            duration = Number(duration);
            s = (Math.floor(duration % 60))
            m = (Math.floor(duration / 60)) % 60
            h = (Math.floor(duration / (60 * 60))) % 24
            days = Math.floor(duration / (60 * 60 * 24))

            if (days < 1) {
                days = 0;
                if (h < 1) {
                    h = 0;
                    if (m < 1) {
                        m = 0;
                        if (s < 1) {
                            s = 0
                            getResultData(true);
                            clearInterval(setIntervalForResult);
                        }

                    }
                }
            }




        }, 1000);

    });
</script>
<div class="result-wrapper">
    <div class="q-header">
        <!-- <div class="win-action" on:click={()=>window.history.back()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-arrow-left">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
        </div> -->
        <div class="exam-info">
            <!-- {doneTestObj.testObj ? doneTestObj.testObj.name : ""} -->
        </div>

        {#if !doneTestObj.durationForResult && !days && !h && !m && !s}
        <div class="review-exam-btn" on:click={()=>navigate("/review/" + doneTestId+ "/"+ rank + "/1/1")}>
            <span> Review Test </span>

            <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 20px;" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="feather feather-arrow-right">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
        </div>
        {/if}
    </div>
    <div class="result-container">

        {#if loading}
            <LoadingProgress />
        {:else}
        <div class="test-details">

            <div class="test-icon">
                <svg xmlns="http://www.w3.org/2000/svg" style="color:#8392a5;" width="56" height="56"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="feather feather-clipboard">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                </svg>
            </div>
            <div class="test-info">
                <div class="test-name"> {doneTestObj.testObj? doneTestObj.testObj.name : ""}</div>
                <div class="test-desc"> {doneTestObj.testObj? doneTestObj.testObj.description?
                    doneTestObj.testObj.description : "" : ""}</div>
            </div>
            <div class="test-dif">
                <div>
                    Submitted On
                </div>
                <div class="test-desc">
                    {doneTestObj.endedOn ? ((new Date(doneTestObj.endedOn)).toDateString()) : ""}
                </div>
            </div>

        </div>
        <div class="result-body">
            <div class="test-stats">

                <div class="score-card">
                    {#if !doneTestObj.durationForResult && !days && !h && !m && !s}
                    <div class="over-all-score">
                        <span>Your Score</span>
                        <span class="jumbo">{doneTestObj.total.totalMarks ? doneTestObj.total.totalMarks :
                            "0"}/{doneTestObj.total.maximumMarks ? doneTestObj.total.maximumMarks : "0"}</span>
                        <span>in this exam</span>
                    </div>
                    {:else}
                    <div class="over-all-score">
                        {#if days != undefined}
                            <span>Result will be displayed in :</span>
                            {#if days!=0}
                            <span>
                                <h3>{days} Days & {h} Hours & {m} Minutes</h3>
                            </span>
                            {:else}
                            <span>
                                <h3>{h} Hours & {m} Minutes & {s} Seconds</h3>
                            </span>
                            {/if}
                        {/if}
                    </div>
                    {/if}
                    <div class="over-all-others">
                        <div class="o-row">
                            <div class="o-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="#0168fa" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-clock">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                            </div>
                            <div class="o-text">
                                {#if Math.floor(testDuration / 3600) != 0}
                                {Math.floor(testDuration / 3600)}h : {Math.floor(testDuration % 3600 / 60)}m :
                                {Math.floor(testDuration % 3600 % 60)}s
                                {:else}
                                {Math.floor(testDuration % 3600 / 60)}m : {Math.floor(testDuration % 3600 % 60)}s
                                {/if}
                            </div>
                        </div>
                        {#if !doneTestObj.durationForResult && !days && !h && !m && !s}
                        <div class="o-row">
                            <div class="o-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="#10b759" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-check-circle">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </svg>
                            </div>
                            <div class="o-text">
                                {doneTestObj.total.totalCorrectAns? doneTestObj.total.totalCorrectAns: "0"} correctly
                                answered
                            </div>
                        </div>

                        <div class="o-row">
                            <div class="o-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="#dc3505" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-x-circle">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="15" y1="9" x2="9" y2="15"></line>
                                    <line x1="9" y1="9" x2="15" y2="15"></line>
                                </svg>
                            </div>
                            <div class="o-text">
                                {doneTestObj.total.totalWrongAns ? doneTestObj.total.totalWrongAns : "0"} questions
                                wrong
                            </div>
                        </div>

                        {:else}

                        <div class="o-icon">

                        </div>
                        <div class="o-text">
                            {#if resultDate}
                                <p style="margin:1px;">Result Date : {resultDate}</p>
                            {/if}
                            
                        </div>

                        {/if}

                        <div style="border-bottom:1px solid #ddd; height:1px;margin-top:15px;margin-bottom: 10px;">
                        </div>

                        <div class="o-time">
                            <div><span>Started</span> <span>Ended</span></div>
                            <div class="o-time-value">
                                <span>{doneTestObj.startedAt ? formatAMPM(doneTestObj.startedAt) : "0"}</span>
                                <span>{doneTestObj.endedOn ? formatAMPM(doneTestObj.endedOn) : "0"} </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div id="graph3">
                    </div>
                    <!-- <canvas id="graph2" ></canvas> -->
                    <div id="graph" style="display: none;">
                        {#each labelsArr as item}
                        <div style="display: none;">{item}</div>
                        {/each}
                        <ul>
                            <span>
                                <li></li>
                                <li></li>
                            </span>
                            <span>
                                <li></li>
                                <li></li>
                            </span>
                            <span>
                                <li></li>
                                <li></li>
                            </span>
                        </ul>
                    </div>

                    <div id="labels" style="display: none;">Years : </div>
                </div>
                <div class="more-details">



                    {#if !doneTestObj.durationForResult && !days && !h && !m && !s}
                    <div class="total-row">
                        <div class="total-label">
                            Marks obtained
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalMarks ? doneTestObj.total.totalMarks : "0"}
                        </div>
                    </div>

                    <div class="total-row">
                        <div class="total-label">
                            Questions in test
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalQuestions ? doneTestObj.total.totalQuestions : "0"}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Positive marks
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalPMarks ? doneTestObj.total.totalPMarks: "0"}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Negative marks
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalNMarks ? doneTestObj.total.totalNMarks : "0"}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Question attempted
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalAttempted ? doneTestObj.total.totalAttempted : "0"}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Correctly answered
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalCorrectAns ? doneTestObj.total.totalCorrectAns : "0"}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Wrongly answered
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalWrongAns ? doneTestObj.total.totalWrongAns : "0"}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Not Answered
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalNotAnswered? doneTestObj.total.totalNotAnswered : "0"}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Not Visited
                        </div>
                        <div class="total-value">
                            {doneTestObj.total.totalNotVisited ? doneTestObj.total.totalNotVisited : "0"}
                        </div>
                    </div>
                    {#each testSections as section }
                    <div style="margin-top: 10px; margin-left: 10px; margin-bottom: 10px;">
                        <div class="total-label" style=" font-weight: bold; text-transform: capitalize;">
                            {section}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Attempted
                        </div>
                        <div class="total-value">
                            {sectionalResult[section].result.totalAttempted}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Correct
                        </div>
                        <div class="total-value">
                            {sectionalResult[section].result.correct}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Wrong
                        </div>
                        <div class="total-value">
                            {sectionalResult[section].result.wrong}
                        </div>
                    </div>
                    <div class="total-row">
                        <div class="total-label">
                            Score
                        </div>
                        <div class="total-value">
                            {sectionalResult[section].result.marks}
                        </div>
                    </div>
                    {/each}
                    {/if}
                </div>

            </div>
            {#if rankList.length}
            <div class="test-leaderboard">
                <div class="rank-div">
                    <div class="rank-txt">
                        Your Rank :
                    </div>
                    <div class="rank-img">
                        {#if rank == -1}
                        <span>-</span>
                        {:else}
                        <span>{rank}</span>
                        {/if}
                    </div>
                </div>

                <div class="rank-list" style="display: none;">
                    {#each rankList as item, index}
                    <div class="rank-row">
                        <div class="s-name">
                            {index+1}. {item.userData[0].name}
                        </div>
                        <div class="s-marks">
                            {item.total.totalMarks}
                        </div>
                    </div>
                    {/each}
                </div>
            </div>
            {/if}
        </div>
        {/if}
    </div>
</div>